import { render, staticRenderFns } from "./DealLoastConfirmModal.vue?vue&type=template&id=19d1010c&"
import script from "./DealLoastConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DealLoastConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports